<template>
    <div class="uk-padding uk-background-muted" style="min-height: 75vh">
        <div class="uk-container uk-container-small">
            <h1 class="uk-text-center">Contact Us</h1>
            <div class="uk-card uk-card-default  uk-child-width-1-2@s uk-margin" uk-grid>


                <div>
                    <div class="uk-card-body">
                        <br>
                        <div>
                            <img src="/logo.png" alt="">
                        </div>
                        <br>
                        <h3 class="uk-card-title">Aeorion Software Solutions</h3>
                        <p>
                            Northern Caribbean University, <br>
                            Manchester Road, <br>
                            Manchester, Jamaica
                        </p>

                        <p>
                            Tel: 1-876-963-7300 <br>
                            Fax: 1-876-962-0075 <br>
                            Email : support@aeorion.com
                        </p>
                    </div>
                </div>
                <div class="uk-card-media-left ">
                    <div class="uk-card-body">

                        <form  @submit.prevent="validateForm('form-1')"  data-vv-scope="form-1">
                            <fieldset class="uk-fieldset">

                                <legend class="uk-legend" style="color: #004e9c;">Request a Demo</legend>

                                <div class="uk-margin">
                                    <label class="uk-text-small uk-text-muted" for="">Name</label>
                                    <input class="uk-input" type="text"
                                           placeholder="Your Name" name="name" v-validate="'required'"
                                           v-model="name" :class="{'input': true, 'is-danger': errors.has('form-1.name') }">
                                    <span v-show="errors.has('form-1.name')" class="help uk-text-danger uk-text-small">{{ errors.first('form-1.name') }}</span>
                                </div>
                                <div class="uk-margin">
                                    <label class="uk-text-small uk-text-muted" for="">Email Address</label>
                                    <input class="uk-input" type="text"
                                           v-model="email"
                                           placeholder="Email Address" name="email" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.email') }">
                                    <span v-show="errors.has('form-1.email')" class="help uk-text-danger uk-text-small">{{ errors.first('form-1.email') }}</span>
                                </div>
                                <div class="uk-margin">
                                    <label class="uk-text-small uk-text-muted" for="">Phone Number</label>
                                    <masked-input
                                            type="text"
                                            name="phone"
                                            class="uk-input"
                                            v-model="phone"
                                            :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                            :guide="false"
                                            v-validate="'required'"
                                            :class="{'input': true, 'uk-danger': errors.has('form-1.phone') }"
                                            placeholder="Phone Number">
                                    </masked-input>
                                   <!-- <input class="" type="text" placeholder="Phone Number" name="phone" >-->
                                    <span v-show="errors.has('form-1.phone')" class="help uk-text-danger uk-text-small">{{ errors.first('form-1.phone') }}</span>
                                </div>
                                <div class="uk-margin">
                                    <label class="uk-text-small uk-text-muted" for="">Company Name</label>
                                    <input class="uk-input" type="text"
                                           v-model="companyName"
                                           placeholder="Company Name" name="companyName" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.companyName') }">
                                    <span v-show="errors.has('form-1.companyName')" class="uk-text-danger uk-text-small">{{ errors.first('form-1.companyName') }}</span>
                                </div>
                                <div class="uk-margin">
                                    <button class="uk-button uk-button-secondary uk-align-right" style="background-color: #004e9c;">Send</button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UIkit from 'uikit'
    import MaskedInput from 'vue-text-mask'
    import axios from 'axios'
    export default {
        name: "ecard",
        data () {
            return {
                phone: '',
                name: '',
                email: '',
                companyName: ''
            }
        },
        components: {
            MaskedInput
        },
        methods: {
            validateForm(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        // eslint-disable-next-line
                        console.log(result)
                        let self = this
                        alert('Form Submitted!');
                        axios.post('https://ncuws2.ncu.edu.jm/api/email/send', {
                            Name: this.name,
                            ContactTelephone: this.phone,
                            ContactEmail: this.email,
                            Subject: this.companyName,
                            Message: `${this.companyName} has requested a demo of the system. <br> The can be contacted by phone at ${this.phone} or via email at ${this.email}.
                                <br> The name of the contact person is ${this.name}. <br><br> This email was sent via the Aeorion Software Solutions Website. <br>`,

                            /*${this.companyName} has requested a demo of the system. The can be contacted by phone at ${this.phone} or via email at ${this.email}.
                                The name of the contact person is ${this.name}. {<br>} this email was sent via the Aeorion Software Solutions Website*/
                        })
                            .then(function (response) {
                                console.log(response);
                                self.name = '';
                                self.phone = '';
                                self.email = '';
                                self.companyName = '';
                                self.$validator.reset()
                                UIkit.notification('Your demo request has successfully been sent', 'success', {pos: 'bottom-right'});
                            })
                            .catch(function (error) {
                                console.log(error);
                                UIkit.notification('Your request was not successful. Please try again later', 'danger', 'bottom-right');
                            });
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>